/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { SubjectFollowerSettings } from "../../../../gen/subject_follower/subject_follower_settings";
import { SubjectSettings } from "../../../infrastructure/flight_deck/settings";

export const protobufPackage = "skills";

export interface SetSubjectFollowerSettingsActionArgs {
  /** Old settings will have no impact on the action */
  settings:
    | SubjectFollowerSettings
    | undefined;
  /** New settings */
  settings2: SubjectSettings | undefined;
}

export interface SetSubjectFollowerSettingsResultData {
}

export interface SetSubjectFollowerSettingsActionStateData {
}

function createBaseSetSubjectFollowerSettingsActionArgs(): SetSubjectFollowerSettingsActionArgs {
  return { settings: undefined, settings2: undefined };
}

export const SetSubjectFollowerSettingsActionArgs = {
  encode(message: SetSubjectFollowerSettingsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.settings !== undefined) {
      SubjectFollowerSettings.encode(message.settings, writer.uint32(10).fork()).ldelim();
    }
    if (message.settings2 !== undefined) {
      SubjectSettings.encode(message.settings2, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetSubjectFollowerSettingsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetSubjectFollowerSettingsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.settings = SubjectFollowerSettings.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.settings2 = SubjectSettings.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetSubjectFollowerSettingsActionArgs {
    return {
      settings: isSet(object.settings) ? SubjectFollowerSettings.fromJSON(object.settings) : undefined,
      settings2: isSet(object.settings2) ? SubjectSettings.fromJSON(object.settings2) : undefined,
    };
  },

  toJSON(message: SetSubjectFollowerSettingsActionArgs): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = SubjectFollowerSettings.toJSON(message.settings);
    }
    if (message.settings2 !== undefined) {
      obj.settings2 = SubjectSettings.toJSON(message.settings2);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetSubjectFollowerSettingsActionArgs>, I>>(
    base?: I,
  ): SetSubjectFollowerSettingsActionArgs {
    return SetSubjectFollowerSettingsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetSubjectFollowerSettingsActionArgs>, I>>(
    object: I,
  ): SetSubjectFollowerSettingsActionArgs {
    const message = createBaseSetSubjectFollowerSettingsActionArgs();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? SubjectFollowerSettings.fromPartial(object.settings)
      : undefined;
    message.settings2 = (object.settings2 !== undefined && object.settings2 !== null)
      ? SubjectSettings.fromPartial(object.settings2)
      : undefined;
    return message;
  },
};

function createBaseSetSubjectFollowerSettingsResultData(): SetSubjectFollowerSettingsResultData {
  return {};
}

export const SetSubjectFollowerSettingsResultData = {
  encode(_: SetSubjectFollowerSettingsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetSubjectFollowerSettingsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetSubjectFollowerSettingsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetSubjectFollowerSettingsResultData {
    return {};
  },

  toJSON(_: SetSubjectFollowerSettingsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetSubjectFollowerSettingsResultData>, I>>(
    base?: I,
  ): SetSubjectFollowerSettingsResultData {
    return SetSubjectFollowerSettingsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetSubjectFollowerSettingsResultData>, I>>(
    _: I,
  ): SetSubjectFollowerSettingsResultData {
    const message = createBaseSetSubjectFollowerSettingsResultData();
    return message;
  },
};

function createBaseSetSubjectFollowerSettingsActionStateData(): SetSubjectFollowerSettingsActionStateData {
  return {};
}

export const SetSubjectFollowerSettingsActionStateData = {
  encode(_: SetSubjectFollowerSettingsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetSubjectFollowerSettingsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetSubjectFollowerSettingsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetSubjectFollowerSettingsActionStateData {
    return {};
  },

  toJSON(_: SetSubjectFollowerSettingsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetSubjectFollowerSettingsActionStateData>, I>>(
    base?: I,
  ): SetSubjectFollowerSettingsActionStateData {
    return SetSubjectFollowerSettingsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetSubjectFollowerSettingsActionStateData>, I>>(
    _: I,
  ): SetSubjectFollowerSettingsActionStateData {
    const message = createBaseSetSubjectFollowerSettingsActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
